const GLOBAL = {
  DOMAIN: process.env.REACT_APP_DOMAIN,
  ORDER_MANAGEMENT_ENDPOINT: process.env.REACT_APP_ORDER_MANAGEMENT_ENDPOINT,
}

export default GLOBAL
